// url 中携带 performance entry key, 用于sentry上报请求的网络详细信息
export const PERFORMANCE_ENTRY_KEY = '_pk';

export const AXIOS_ERROR_TIMEOUT_ETIMEDOUT = 'ETIMEDOUT';

export const AXIOS_ERROR_TIMEOUT_ECONNABORTED = 'ECONNABORTED';
